"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.sso = exports.notification = exports.messages = exports.link = exports.eids = exports.default = void 0;
var _propTypes = _interopRequireWildcard(require("prop-types"));
function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function (nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || typeof obj !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
const sso = _propTypes.default.shape({
  login: _propTypes.default.shape({
    href: _propTypes.default.string.isRequired
  }).isRequired
});
exports.sso = sso;
const link = _propTypes.default.shape({
  href: _propTypes.string,
  title: _propTypes.string
});
exports.link = link;
const eids = _propTypes.default.shape({
  click: _propTypes.string,
  impression: _propTypes.string
});
exports.eids = eids;
const messages = _propTypes.default.shape({
  closeText: _propTypes.node.isRequired,
  noNotificationsTitle: _propTypes.node.isRequired,
  noNotificationsText: _propTypes.node.isRequired,
  headerText: _propTypes.node.isRequired,
  failedNotificationsTitle: _propTypes.node.isRequired,
  failedNotificationsText: _propTypes.node.isRequired,
  failedNotificationsLink: _propTypes.node.isRequired
});
exports.messages = messages;
const notification = _propTypes.default.shape({
  title: _propTypes.string,
  content: _propTypes.string.isRequired,
  link: _propTypes.string,
  priority: _propTypes.string,
  subcategory: _propTypes.string,
  eids: eids,
  viewed: _propTypes.bool
});
exports.notification = notification;
const shapes = {
  sso,
  link,
  eids,
  messages,
  notification
};
exports.default = shapes;